import React from 'react';
import { KeyRound, Activity, AlertTriangle, PowerOff, Clock } from 'lucide-react';
import { StatCard, ActivationsChart, RecentActivations } from '../DashboardCards';

/**
 * Admin — Dashboard tab. Stats cards + activations chart + recent activations.
 * Extracted from AdminPanel.jsx on 29/05/2026 (code review refactor).
 */
export default function DashboardTab({ stats }) {
  if (!stats) {
    return <div className="text-center text-slate-500 py-12">Chargement des statistiques...</div>;
  }
  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        <StatCard label="Total licences" value={stats.total} color="text-white" icon={KeyRound} />
        <StatCard label="Actives" value={stats.active} color="text-money" icon={Activity} />
        <StatCard label="Expirées" value={stats.expired} color="text-danger" icon={AlertTriangle} sub={`Taux : ${stats.expiration_rate}%`} />
        <StatCard label="Désactivées" value={stats.disabled} color="text-slate-500" icon={PowerOff} />
        <StatCard label="Activations aujourd'hui" value={stats.today_activations} color="text-accent" icon={Clock} sub={`Total : ${stats.total_activations}`} />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <ActivationsChart data={stats.activations_per_day} />
        <RecentActivations data={stats.recent_activations} />
      </div>
    </>
  );
}
